import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../../environment";
import { DropdownItem } from "../interfaces/dropdown-item.interface";
import { Level } from "../interfaces/level.interface";
import { sanitizeParams } from "../sanitize-params";

@Injectable({ providedIn: "root" })
export class LevelClient {
  endpoint = "level";
  constructor(private httpClient: HttpClient) {}

  addLevel(level: Partial<Level>, corpId: string) {
    return this.httpClient.post(
      `${environment.endpoint}/${this.endpoint}/add`,
      { ...level, corpid: corpId }
    );
  }

  editLevel(level: Partial<Level>, corpId: string) {
    return this.httpClient.put(
      `${environment.endpoint}/${this.endpoint}/edit`,
      { ...level, corpid: corpId }
    );
  }

  deleteLevel(levelId: number) {
    return this.httpClient.delete(
      `${environment.endpoint}/${this.endpoint}/delete/${levelId}`
    );
  }

  getLevels(
    facilityId: string,
    payorId: number,
    fromDate?: string,
    patientFacilityPayorId?: number
  ): Observable<{ levels: DropdownItem[]; iscontractpresent: boolean }> {
    const params = new HttpParams({
      fromObject: sanitizeParams({
        facilityId,
        payorId,
        dateString: fromDate || null,
        patientfacilitypayorid: patientFacilityPayorId ?? null,
      }),
    });
    return this.httpClient.get<{
      levels: DropdownItem[];
      iscontractpresent: boolean;
    }>(`${environment.endpoint}/patient/getlevels-dropdown`, { params });
  }
}
